//date range picker JS located in search-results global.js
